// extracted by mini-css-extract-plugin
module.exports = {"Featured":"Page_Featured_Featured__ioJyS","Image":"Page_Featured_Image__2O06j"};